import { atom } from 'jotai';
export var outagesAtom = atom(null);
